import axios from "axios";
class OcrIdCardImageService {
    private axios = axios.create({
        baseURL: "https://asia-southeast1-autotrimitra.cloudfunctions.net/api-cdn-trimitra-biz__ocr-document",
    });

    public async getData(inputData?: any) {
        try {
            return await this.axios.post<any>("/ocr/id-card", inputData, {
                headers: {
                    "Content-Type": "application/json",
                    "SecretKey": "Mn3zrubT3AM5NA8UFXZO6BgV6Rd69YrH",
                },
            });
        } catch (e: any) {
            throw new Error(e.response.data.error.message);
        }
    }
}

export const ocrIdCardImageService = new OcrIdCardImageService();
